import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  FaWhatsapp,
  FaGlobe,
  FaFacebook,
  FaShareAlt,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaGithub,
  FaSnapchat,
  FaPinterest,
  FaTelegram,
  FaSkype,
  FaVimeo,
  FaYelp,
  FaSpotify,
  FaReddit,
  FaTumblr,
  FaXing,
  FaFlickr,
  FaLine,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { IoPersonAdd } from "react-icons/io5";
import { IoIosCloseCircle } from "react-icons/io";
import { RiSendPlaneFill } from "react-icons/ri";
import { GrLinkPrevious, GrLinkNext } from "react-icons/gr";
import { IoCloseSharp } from "react-icons/io5";
import { TbWorldWww } from "react-icons/tb";

import { useNavigate } from "react-router-dom";
import no_user from "../public/assets/img/no_user.png";
import whatsapp from "../public/assets/img/whatsapp.png";
import facebook from "../public/assets/img/facebook.png";
import twitter from "../public/assets/img/twitter.png";
import skype from "../public/assets/img/skype.png";
import linkedin from "../public/assets/img/linkedin.png";
import telegram from "../public/assets/img/telegram.png";
import email from "../public/assets/img/email.png";
import copy from "../public/assets/img/copy.png";
import { useLocation, Link } from "react-router-dom";
import MetaHelmet from "../MetaHelmet";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Vcard = () => {

  const navigate = useNavigate();
  const [businessData, setBusinessData] = useState({});
  const [imageData, setImageData] = useState({});
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [images, setImages] = useState([]);
  const [whatsappname, setWhatsappName] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [message, setMessage] = useState("");
  const fullImageList = (Array.isArray(businessData?.image) ? businessData.image : []).concat(images);

  const [previewIndex, setPreviewIndex] = useState(null);
  const [touchStartX, setTouchStartX] = useState(null);
  const hasFetch = useRef(true);
  const location = useLocation();
  const { id } = location.state || {};

  useEffect(() => {
    if (id && hasFetch.current) {
      fetchBusinessData(id);
      hasFetch.current = false;
    } else {
      const params = new URLSearchParams(location.search);
      const userId = params.get("id");
      console.log("user id is------->", userId);

      fetchBusinessData(userId);
    }
  }, [id]);

  const fetchBusinessData = async (id) => {
    const token = localStorage.getItem("token");
    // if (!token) {
    //   navigate("/");
    //   return;
    // }
    const config = {
      headers: {
        // Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.get(
        `${API_BASE_URL}get-business/${id}`,
        config
      );
      const serialized = response.data.serialized_business;
      const imageKeys = ['image1', 'image2', 'image3', 'image4', 'image5'];
      const images = imageKeys.map(key => serialized[key]).filter(Boolean);
      serialized.image = images;

      setBusinessData(serialized);
      setImageData(response.data.serialized_business);
      setFilteredUsers(response.data.serialized_business.products_and_services)
      console.log("response.data.serialized_business.products_and_services", response.data.serialized_business.products_and_services)
      if (response.data.serialized_business?.colour) {
        document.documentElement.style.setProperty('--theme-vcard', response.data.serialized_business.colour);
      }
    } catch (error) {
      console.error("Error fetching business data:", error);
    }
  };

  const toggleSocialIcon = (userId) => {
    setSelectedUserId(selectedUserId === userId ? null : userId);
    setIsModalOpen(true);
  };

  const shareVCard = (platform, business) => {

    const vCardURL = `${process.env.REACT_APP_FRONTEND_URL}vcard/${business.full_name.toLowerCase().replace(/\s+/g, "-")}`;

    const userId = business.id;
    const platformURLs = {
      whatsapp: `https://wa.me/?text=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Flocalhost%3A3000%2Fvcard%2Ftest%3Fid%3D146=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}`,
      email: `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check%20out%20this%20vCard&body=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(
        `${vCardURL}?id=${userId}`
      )}&text=Check%20out%20this%20vCard`,
      skype: `skype:?chat&message=${encodeURIComponent(`${vCardURL}?id=${userId}`)}`,
    };

    if (platform === "download") {
      const link = document.createElement("a");
      link.href = vCardURL;
      link.click();
    } else if (platformURLs[platform]) {
      window.open(platformURLs[platform], "_blank");
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };


  const getYoutubeVideoId = (url) => {
    if (!url) return null;
    const regex =
      /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  const videoId = getYoutubeVideoId(businessData.youtube_link);

  const handleMobileChange = (e) => {
    const value = e.target.value;

    if (/^\d{0,10}$/.test(value)) {
      setMobile(value);

      if (value.length === 10) {
        setMobileError("");
      } else {
        setMobileError("Mobile number must be exactly 10 digits");
      }
    } else {
      setMobile(value);
      setMobileError("Only numbers are allowed");
    }
  };
  const formatCompanyURL = (name) => {
    if (!name) return '#';
    if (name.startsWith("http://") || name.startsWith("https://")) {
      return name;
    }
    if (name.includes('.') && !name.includes(' ')) {
      return `https://${name}`;
    }
    const searchQuery = encodeURIComponent(name);
    return `https://www.google.com/search?q=${searchQuery}`;
  };

  const handleWhatsapp = (e) => {
    e.preventDefault();

    const mobileWithCode = `91${businessData.phone}`;

    const fullMessage = `Name: ${whatsappname}%0AMobile: ${mobile}%0AMessage: ${message}`;

    const whatsappLink = `https://wa.me/${mobileWithCode}?text=${fullMessage}`;

    window.open(whatsappLink, "_blank");
  };
  const isFormValid =
    whatsappname.trim() !== "" &&
    message.trim() !== "" &&
    /^\d{10}$/.test(mobile);


  const copyLink = () => {

    if (navigator.clipboard) {
      const linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}vcard/${businessData.full_name.toLowerCase().replace(/\s+/g, '-')}` + `?id=${businessData.id}`;

      navigator.clipboard.writeText(linkToCopy)
        .then(() => {
          closeModal();
          setTimeout(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 3000);
          }, 300);
        })
        .catch((err) => {
          console.error('Error copying link: ', err);
        });
    } else {
      const linkToCopy = `${process.env.REACT_APP_FRONTEND_URL}vcard/${businessData.full_name.toLowerCase().replace(/\s+/g, '-')}` +
        `?id=${businessData.id}`;

      const textarea = document.createElement('textarea');
      textarea.value = linkToCopy;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      closeModal();
      setTimeout(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      }, 300);
    }
  };

    const generateVCard = (businessData, imageData) => {
      let websitesArray = [];
  
      if (Array.isArray(businessData.websites)) {
        websitesArray = businessData.websites;
      } else if (typeof businessData.websites === "string") {
        try {
          const parsedWebsites = JSON.parse(businessData.websites);
          if (Array.isArray(parsedWebsites)) {
            websitesArray = parsedWebsites;
          }
        } catch (e) {
          websitesArray = businessData.websites.split(",").map(url => url.trim());
        }
      }
      const websitesFormatted = websitesArray.join("\nURL;TYPE=WORK:");
  
      let vCardData = `BEGIN:VCARD
  VERSION:3.0
  FN:${businessData.full_name || businessData.company_name}
  N:;${businessData.full_name};;;
  ORG:${businessData.company_name}
  TEL;TYPE=WORK,VOICE:${businessData.phone || ''}
  EMAIL;TYPE=WORK:${businessData.email || ''}
  ADR;TYPE=WORK:;;${businessData.address || ""}
  URL;TYPE=WORK:${websitesFormatted}
  `;
  
      vCardData += `
  NOTE:${businessData.note}
  PHOTO;ENCODING=BASE64;TYPE=PNG:${imageData.img}
  END:VCARD
    `;
  
      const blob = new Blob([vCardData], { type: "text/vcard" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${businessData.full_name}_vCard.vcf`;
      link.click();
    };

  const handleImageClick = (index) => {
    setPreviewIndex(index);
  };

  const closePreview = () => {
    setPreviewIndex(null);
  };

  const goNext = () => {
    setPreviewIndex((prev) => (prev + 1) % fullImageList.length);
  };

  const goPrev = () => {
    setPreviewIndex((prev) => (prev - 1 + fullImageList.length) % fullImageList.length);
  };

  useEffect(() => {
    document.body.style.overflow = previewIndex !== null ? "hidden" : "auto";
    return () => (document.body.style.overflow = "auto");
  }, [previewIndex]);

  const handleTouchStart = (e) => setTouchStartX(e.changedTouches[0].clientX);
  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;
    if (diff > 50) goNext();
    if (diff < -50) goPrev();
    setTouchStartX(null);
  };

  const currentImg = fullImageList[previewIndex];
  const currentSrc = currentImg && (typeof currentImg === "string" ? currentImg : URL.createObjectURL(currentImg));

  const generateFullUrl = (platform, link) => {
    if (link.startsWith("http://") || link.startsWith("https://")) {
      return link;
    }
    switch (platform) {
      case "Website":
        return `https://google.com/search?q=${link}`;
      case "Facebook":
        return `https://facebook.com/${link}`;
      case "Twitter":
        return `https://twitter.com/${link}`;
      case "Instagram":
        return `https://instagram.com/${link}`;
      case "LinkedIn":
        return `https://linkedin.com/in/${link}`;
      case "YouTube":
        return `https://youtube.com/c/${link}`;
      case "GitHub":
        return `https://github.com/${link}`;
      case "WhatsApp":
        return `https://wa.me/${link}`;
      case "Snapchat":
        return `https://snapchat.com/add/${link}`;
      case "Pinterest":
        return `https://pinterest.com/${link}`;
      case "Telegram":
        return `https://t.me/${link}`;
      case "Skype":
        return `https://www.skype.com/${link}`;
      case "Vimeo":
        return `https://vimeo.com/biz/${link}`;
      case "Yelp":
        return `https://yelp.com/biz/${link}`;
      case "Spotify":
        return `https://open.spotify.com/user/${link}`;
      case "Reddit":
        return `https://reddit.com/u/${link}`;
      default:
        return link;
    }
  };
  return (
    <>
      <MetaHelmet
        title={`${businessData.full_name} | Digital Business Card | LocalShouts`}
        description={`Explore ${businessData.full_name} smart digital business card powered by LocalShouts. Instantly access contact details, social links, and professional info – no app needed, just scan & connect.`}
        keywords={` ${businessData.full_name}, LocalShouts, digital business card, smart vCard, online visiting card, paperless card, contact Sunjay Baveja, mobile business card, professional profile`}
        image={imageData.img ? imageData.img : no_user}
      />
      <div id="vCard" className="container vCard-container-outer mx-auto">
        <div className="vCard-body">
          <div className="vCard-container mx-auto">
            <div className="vCard">
              <div className="vHead">
                <div className="bg-shape"
                  style={{ backgroundColor: businessData?.colour, }}>
                </div>
                <div className="head-info">
                  <h2>{businessData.full_name}</h2>
                  <div className="profile">
                    <img
                      src={imageData.img ? imageData.img : `${no_user}`}
                      alt="logo"
                      style={{ width: "100%" }}
                    />
                  </div>
                  <div className="com-pos">
                    <p>
                      {businessData.designation}
                      <br />
                      at <strong>{businessData.company_name}</strong>
                    </p>
                  </div>
                  <div className="contacts mx-auto">
                    <ul>
                      <li>
                        <Link to={`tel:${businessData.phone}`}
                          className="contact-card">
                          <i className="icon-phone"></i>
                          Call Us
                        </Link>
                      </li>
                      <li>
                        <Link to={`https://wa.me/${businessData.phone}`}
                          target="_blank"
                          className="contact-card">
                          <i className="icon-whatsapp"></i>
                          Whatsapp
                        </Link>
                      </li>
                      <li>
                        <Link to={`https://maps.google.com/?q=${encodeURIComponent(
                          businessData.address
                        )}`}
                          target="_blank"
                          className="contact-card">
                          <i className="icon-direction"></i>
                          Direction
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="vBody">
                {businessData.note && (
                  <div className="vCard-about">
                    <h3>About me</h3>
                    <p>{businessData.note}</p>
                  </div>
                )}
                <div className="vCard-d">
                  {businessData.phone && (
                    <div className="d-item">
                      <i className="icon-phone"></i>
                      <span>Mobile</span>
                      <h2>
                        <Link to={`tel:${businessData.phone}`}>
                          {businessData.phone}
                        </Link>
                      </h2>
                    </div>
                  )}
                  {businessData.email && (
                    <div className="d-item">
                      <i className="icon-envelope"></i>
                      <span>Email</span>
                      <h2>
                        <Link to={`mailto:${businessData.email}`}>
                          {businessData.email}
                        </Link>
                      </h2>
                    </div>
                  )}
                  {businessData.address && (
                    <div className="d-item">
                      <i className="icon-location"></i>
                      <span>Location</span>
                      <h2>
                        <Link
                          to={`https://maps.google.com/?q=${encodeURIComponent(
                            businessData.address
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          {businessData.address}
                        </Link>
                      </h2>
                    </div>
                  )}
                  {businessData.company_name && (
                    <div className="d-item">
                      <i className="icon-briefcase"></i>
                      <span>
                        {businessData?.designation || "Job Role"}
                      </span>
                      <h2>
                        <Link
                          to={formatCompanyURL(businessData.company_name)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {businessData?.company_name}
                        </Link>
                      </h2>
                    </div>
                  )}
                </div>
                {Array.isArray(businessData.websites) &&
                  businessData.websites.filter(site => site?.trim()).length > 0 && (
                    <div className="sites">
                      <div>
                        <h3>Websites</h3>
                      </div>
                      {businessData.websites.map((website, index) => {
                        if (!website?.trim()) return null;

                        const websiteUrl =
                          website.startsWith("http://") || website.startsWith("https://")
                            ? website
                            : `https://${website}`;

                        return (
                          <div key={index} className="d-item">
                            <div className="site-list d-flex flex-column">
                              <div className="d-flex">
                                <div className="site-logo">
                                  {/* <img
                                    src="https://cdn0.iconfinder.com/data/icons/social-circle-3/72/Codepen-512.png"
                                    width="100%"
                                    height="100%"
                                    alt="website logo"
                                  /> */}
                                  <TbWorldWww
                                    style={{
                                      width: "100%",
                                      height: "100%"
                                    }} />
                                </div>
                                <div className="website-url ms-2 d-flex align-items-center">
                                  <Link
                                    to={websiteUrl}
                                    className="text-decoration-none"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {website}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}

                {businessData.links && businessData.links.length > 0 && (
                  <div className="social">
                    <h3>Connect us</h3>
                    {businessData.links.map((link, index) => {
                      let IconComponent;
                      let iconColor;
                      switch (link.platform) {
                        case "Website":
                          IconComponent = FaGlobe;
                          iconColor = "#000000";
                          break;
                        case "Facebook":
                          IconComponent = FaFacebook;
                          iconColor = "#1877F2";
                          break;
                        case "Twitter":
                          IconComponent = FaXTwitter;
                          iconColor = "#000000";
                          break;
                        case "Instagram":
                          IconComponent = FaInstagram;
                          iconColor = "#E4405F";
                          break;
                        case "LinkedIn":
                          IconComponent = FaLinkedin;
                          iconColor = "#0A66C2";
                          break;
                        case "YouTube":
                          IconComponent = FaYoutube;
                          iconColor = "#FF0000";
                          break;
                        case "GitHub":
                          IconComponent = FaGithub;
                          iconColor = "#181717";
                          break;
                        case "WhatsApp":
                          IconComponent = FaWhatsapp;
                          iconColor = "#25D366";
                          break;
                        case "Snapchat":
                          IconComponent = FaSnapchat;
                          iconColor = "#FFFC00";
                          break;
                        case "Pinterest":
                          IconComponent = FaPinterest;
                          iconColor = "#E60023";
                          break;
                        case "Telegram":
                          IconComponent = FaTelegram;
                          iconColor = "#0088CC";
                          break;
                        case "Skype":
                          IconComponent = FaSkype;
                          iconColor = "#00AFF0";
                          break;
                        case "Vimeo":
                          IconComponent = FaVimeo;
                          iconColor = "#1AB7EA";
                          break;
                        case "Yelp":
                          IconComponent = FaYelp;
                          iconColor = "#D32323";
                          break;
                        case "Spotify":
                          IconComponent = FaSpotify;
                          iconColor = "#1DB954";
                          break;
                        case "Reddit":
                          IconComponent = FaReddit;
                          iconColor = "#FF4500";
                          break;
                        case "Tumblr":
                          IconComponent = FaTumblr;
                          iconColor = "#35465C";
                          break;
                        case "Xing":
                          IconComponent = FaXing;
                          iconColor = "#006F3A";
                          break;
                        case "Flickr":
                          IconComponent = FaFlickr;
                          iconColor = "#FF0084";
                          break;
                        case "Line":
                          IconComponent = FaLine;
                          iconColor = "#00C300";
                          break;
                        default:
                          return null;
                      }

                      const fullLink = generateFullUrl(link.platform, link.link);

                      return (
                        <div
                          class="social-icon"
                          key={index}
                          style={{
                            margin: "10px",
                            display: "inline-block",
                          }}
                        >
                          <Link
                            to={fullLink}
                            target="_blank"
                            rel="noopener noreferrer">
                            {IconComponent && (
                              <IconComponent style={{ color: iconColor }} />
                            )}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                )}
                {/* <div className="product-service vcard-border-top">
                <div className="d-flex flex-column w-100">
                  {filteredUsers.some(user => user.flag === 0) && (
                  <>
                  <div>
                    <h3 className="section-header">Products</h3>
                  </div>
                  <div className="product-service-cards d-flex flex-wrap w-100">
                    {filteredUsers.filter(user => user.flag === 0).map((user, index) => (
                      <div key={`product-${index}`} className="w-50 p-1">
                        <div className="product-service-card position-relative">
                          <div className="pro-ser-img w-100">
                            <img src={user.img} alt="product" className="w-100" />
                          </div>

                          {user.jr && (

                            <div className="card-body">
                              <h5 className="card-title">{user.title}</h5>
                              <p className="card-text">{user.description}</p>
                            </div>
                          
                        </div>
                      </div>
                    ))}
                      </div>
                    </>
                  )}
                  
                  {filteredUsers.some(user => user.flag !== 0) && (
                    <>
                      <div className="mt-4">
                        <h3 className="section-header">Services</h3>
                      </div>
                      <div className="product-service-cards d-flex flex-wrap w-100">
                        {filteredUsers.filter(user => user.flag !== 0).map((user, index) => (
                          <div key={`service-${index}`} className="w-50 p-1">
                            <div className="product-service-card position-relative">
                              <div className="pro-ser-img w-100">
                                <img src={user.img} alt="service" className="w-100" />
                              </div>

                              {user.jr && (

                                <div className="card-body">
                                  <h5 className="card-title">{user.title}</h5>
                                  <p className="card-text">{user.description}</p>
                                </div>
                           
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div> */}

                {filteredUsers.some(user => user.flag === 0) && (
                  <div className="product-service vcard-border-top">
                    <div className="d-flex flex-column w-100">
                      <>
                        <div>
                          <h3 className="section-header">Products</h3>
                        </div>
                        <div className="product-service-cards d-flex flex-wrap w-100">
                          {filteredUsers.filter(user => user.flag === 0).map((user, index) => (
                            <div key={`product-${index}`} className="card-cnt w-50 p-1">
                              <div className="product-service-card position-relative">
                                <div className="pro-ser-img w-100">
                                  <img src={user.img} alt="product" className="w-100" />
                                </div>
                                {user.title && (
                                  <div className="card-body">
                                    <h5 className="card-title">{user.title}</h5>
                                    <p className="card-text">{user.description}</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    </div>
                  </div>
                )}

                {filteredUsers.some(user => user.flag !== 0) && (
                  <div className="product-service vcard-border-top">
                    <div className="d-flex flex-column w-100">
                      <>
                        <div>
                          <h3 className="section-header">Services</h3>
                        </div>
                        <div className="product-service-cards d-flex flex-wrap w-100">
                          {filteredUsers.filter(user => user.flag !== 0).map((user, index) => (
                            <div key={`service-${index}`} className="card-cnt w-50 p-1">
                              <div className="product-service-card position-relative">
                                <div className="pro-ser-img w-100">
                                  <img src={user.img} alt="service" className="w-100" />
                                </div>
                                {user.title && (
                                  <div className="card-body">
                                    <h5 className="card-title">{user.title}</h5>
                                    <p className="card-text">{user.description}</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      </>
                    </div>
                  </div>
                )}

                {Array.isArray(fullImageList) && fullImageList.length > 0 && (
                  <div className="gallary vcard-border-top">
                    <div className="d-flex flex-column">
                      <div className="d-flex position-relative">
                        <h3 className="">Gallery</h3>
                      </div>
                      <div className="d-flex flex-wrap">
                        {fullImageList.slice(0, 5).map((img, index) => (
                          <div
                            className="card-cnt img-cnt p-1"
                            key={index}
                            onClick={() => handleImageClick(index)}
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              className="w-100 rounded-2"
                              src={typeof img === "string" ? img : URL.createObjectURL(img)}
                              alt={`Gallery preview ${index}`}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                {previewIndex !== null && (
                  <div
                    className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex justify-content-center align-items-center"
                    style={{ zIndex: 9999 }}
                    onTouchStart={handleTouchStart}
                    onTouchEnd={handleTouchEnd}
                  >
                    <div
                      className="position-relative d-flex align-items-center justify-content-center"
                      style={{
                        width: "500px",
                        height: "350px",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        overflow: "hidden",
                      }}
                    >
                      {fullImageList.length > 1 && (
                        <button
                          onClick={goPrev}
                          className="position-absolute start-0 top-50 translate-middle-y btn btn-light rounded-circle"
                          style={{ zIndex: 1 }}
                        >
                          <GrLinkPrevious />
                        </button>
                      )}
                      <img
                        src={currentSrc}
                        alt="Full preview"
                        className="img-fluid"
                        style={{
                          width: "500px",
                          height: "350px",
                          objectFit: "cover",
                        }}
                      />
                      {fullImageList.length > 1 && (
                        <button
                          onClick={goNext}
                          className="position-absolute end-0 top-50 translate-middle-y btn btn-light rounded-circle"
                          style={{ zIndex: 1 }}
                        >
                          <GrLinkNext />
                        </button>
                      )}
                      <button
                        onClick={closePreview}
                        className="position-absolute top-0 end-0 m-2 btn btn-light rounded-circle"
                        style={{ zIndex: 1 }}
                      >
                        <IoCloseSharp />
                      </button>
                    </div>
                  </div>
                )}
                {videoId && (
                  <div className="yt-videos vcard-border-top">
                    <div className="d-flex flex-column">
                      <div>
                        <h3 className="">Video</h3>
                      </div>
                      {videoId && (
                        <div className="d-flex">
                          <div className="video-cnt w-100 px-1">
                            <iframe
                              width="100%"
                              height="auto"
                              src={`https://www.youtube.com/embed/${videoId}`}
                              frameBorder="0"
                              allowFullScreen
                              title="YouTube Preview"
                            ></iframe>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                <div className="wp-enquiry-form py-3 vcard-border-top">
                  <div className="wp-enquiry-form-body d-flex w-100 flex-column p-4 rounded-2">
                    <div>
                      <h3 className="mb-0">Enquiry form</h3>
                    </div>
                    <form className="w-100" autocomplete="off" onSubmit={handleWhatsapp}>
                      <div class="w-100 mb-3">
                        <div class="form-group">
                          <div class="form-field">
                            <input type="text"
                              class="form-control border-bottom px-0"
                              placeholder="Name"
                              value={whatsappname}
                              onChange={(e) => setWhatsappName(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="w-100 mb-3">
                        <div class="form-group">
                          <div class="form-field">
                            <input type="tel"
                              class="form-control border-bottom px-0"
                              placeholder="Mobile number"
                              value={mobile}
                              maxLength="10"
                              onChange={handleMobileChange}
                            />

                          </div>
                        </div>
                        {mobileError && (
                          <small className="text-danger">{mobileError}</small>
                        )}
                      </div>
                      <div class="w-100 mb-3">
                        <div class="form-group">
                          <div class="form-field">
                            <textarea type="password"
                              rows={3}
                              class="form-control border-bottom px-0"
                              placeholder="Message"
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div class="w-100">
                        <div class="form-group">
                          <div class="form-field border-0 d-flex">
                            <button
                              type="submit"
                              className="btn ls-btn main-btn mx-auto"
                              disabled={!isFormValid}
                              style={{
                                opacity: isFormValid ? 1 : 0.5,
                                cursor: isFormValid ? "pointer" : "not-allowed",
                              }}
                            >
                              Submit&nbsp;<RiSendPlaneFill />
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="add-contacts py-2">
                  <div className="d-flex w-50 mx-auto">
                    <div className="vCard-btn-container mx-2">
                    <div>
                    <button onClick={() => generateVCard(businessData, imageData)}>
                      Download vCard
                    </button>
                  </div>
                      {/* <button
                        className="vCard-btn ls-btn main-btn save-contact-btn"
                        onClick={() => generateVCard(businessData, imageData)}>
                        <IoPersonAdd />
                        &nbsp;Save contact
                      </button> */}
                    </div>
                    <div className="vCard-btn-container mx-2">
                      <button
                        className="vCard-btn ls-btn main-btn share-btn"
                        onClick={() => toggleSocialIcon(businessData.id)}>
                        <FaShareAlt />&nbsp;Share
                      </button>
                    </div>
                  </div>
                  {selectedUserId === businessData.id && isModalOpen && (
                    <div id="myModal" class="share-modal">
                      <div class="modal-content position-relative pt-3 gap-3">
                        <button
                          onClick={closeModal}
                          className="position-absolute border-0 close-modal-btn">
                          <IoIosCloseCircle />
                        </button>
                        <div className="d-flex justify-content-between">

                          <div>
                            <img src={whatsapp}
                              alt="WhatsApp"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("whatsapp", businessData)} />
                          </div>
                          <div>
                            <img src={facebook}
                              alt="Facebook"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("facebook", businessData)} />
                          </div>
                          <div>
                            <img src={twitter}
                              alt="Twitter"
                              style={{
                                width: "2.5rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("twitter", businessData)} />
                          </div>
                          <div>
                            <img src={linkedin}
                              alt="Linkedin"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("linkedin", businessData)} />
                          </div>
                        </div>
                        <div className="d-flex justify-content-between">
                          <div>
                            <img src={email}
                              alt="Email"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("email", businessData)} />
                          </div>
                          <div>
                            <img src={telegram}
                              alt="Telegram"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("telegram", businessData)} />
                          </div>
                          <div>
                            <img
                              src={skype}
                              alt="Skype"
                              style={{
                                width: "2.7rem",
                                cursor: "pointer",
                              }}
                              onClick={() => shareVCard("skype", businessData)} />
                          </div>

                          <div>
                            <div className="rounded-circle bg-dark p-2 copy-btn-ctn">
                              <img src={copy}
                                alt="Copy"
                                style={{
                                  width: "1.7rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => copyLink(businessData)} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {copied && (
                    <div
                      style={{
                        position: "fixed",
                        top: "70%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "8px",
                        zIndex: 1000,
                        textAlign: "center"
                      }}>
                      Link copied to clipboard!
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="vcard-footer-devider vcard-border-top"></div>

      <div className="vcard-footer py-3">
        <div className="text">
          <span>Powered by LocalShouts —</span> <Link to={"https://localshouts.com/vcards"}>Create Your Card</Link>
        </div>
      </div>
    </>
  );
};

export default Vcard;
